import { useMemo } from "react";
import MeritoButton from "../../../components/common/MeritoButtons/MeritoButtons";
import { AuthMethods, IIntegrationPartner, ipEmailClients, IpNames } from "../../../interfaces/interfaces";
import styles from './EmailOtpHeader.module.scss'
import { emailOtpStepInfo } from "./emailOtpHelper";
import { MdClose as CloseIcon } from 'react-icons/md'

type Props = {
    ip: IIntegrationPartner,
    emailOtpStep: {
        currentStep: number,
        previousStep: number,
    };
    handleModalToggle: () => void;
    formValues: {
        email: string,
        emailClient: string,
    }
}

const EmailOtpHeader = ({ ip, emailOtpStep, handleModalToggle, formValues }: Props) => {

    const currentStepConfig: any = emailOtpStep?.currentStep == 0 ? emailOtpStepInfo(ip)[emailOtpStep?.currentStep] : emailOtpStepInfo(ip)[formValues?.emailClient] ? emailOtpStepInfo(ip)[formValues?.emailClient][emailOtpStep?.currentStep] : {};

    const hideLogoSteps = useMemo(() => {
        const hideLogo = new Set([1, 4, 7]);
        const hideLeftContainer = new Set([12]);
        if (ip?.authMethod == AuthMethods.email_otp_password) {
            // hideLogo.push(0)
            hideLeftContainer.add(10);
            hideLeftContainer.add(11);
        }
        if (formValues?.emailClient == ipEmailClients.outlook) {
            hideLogo.delete(4);
        }

        return {
            hideLogo: hideLogo,
            hideLeftContainer: hideLeftContainer,
        };
    }, [ip]);

    // const hideLogo = new Set()

    console.log('hideLogoSteps', hideLogoSteps);

    return (
        <div className={styles.headerContainer}>
            <div className={styles.leftContainer}>
                {hideLogoSteps?.hideLeftContainer?.has(emailOtpStep?.currentStep) ? null :
                    <>
                        {hideLogoSteps?.hideLogo?.has(emailOtpStep?.currentStep) ? null : <div className={styles.ipImgContainer}>
                            <img src={ip?.logo} alt="" />
                        </div>}
                        <div className={styles.title}>
                            {currentStepConfig?.title}
                        </div>
                    </>}
            </div>
            <div className={styles.rightContainer}>
                <MeritoButton
                    type="tertiary"
                    size="md"
                    onlyIcon={true}
                    icon={<CloseIcon />}
                    onClick={() => handleModalToggle()}
                />
            </div>
        </div>
    );
}

export default EmailOtpHeader;